var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4,55.2L50.4,55.2c-0.3,0-0.7,0-1,0c-5.6-0.4-11-3.5-14.6-8.5C31,41.5,29.6,35.1,31,29.1c2.5-11.1,3.9-17.1,5.5-21l0.4-1  h26.8L64,8.1c1.6,3.9,3.1,10,5.1,21.1c1.2,6.7-0.6,13.5-4.9,18.7C60.5,52.5,55.3,55.2,50.4,55.2z M38.9,10.2  c-1.3,3.8-2.8,9.8-5,19.6c-1.2,5.2,0.1,10.7,3.3,15.1c3.2,4.3,7.7,6.9,12.4,7.3c4.2,0.3,8.9-2,12.2-6.1c3.8-4.5,5.3-10.5,4.3-16.3  c-1.8-10.1-3.2-15.9-4.6-19.6H38.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6,53.7c0,0-0.2,0.6-0.4,1.7c-0.2,1.1-0.4,2.6-0.6,4.4c-0.4,3.6-0.7,8.5-0.6,13.4c0,2.4,0.1,4.9,0.2,7.1  c0.1,1.1,0.2,2.2,0.2,3.3c0.1,1,0.2,2,0.3,2.9c0.4,3.6,0.9,6.1,0.9,6.1h-7.3c0,0,0.5-2.4,0.9-6.1c0.1-0.9,0.2-1.9,0.3-2.9  c0.1-1,0.2-2.1,0.2-3.3c0.1-2.3,0.2-4.7,0.2-7.1c0.1-4.9-0.2-9.7-0.6-13.4c-0.2-1.8-0.4-3.3-0.6-4.4c-0.2-1.1-0.4-1.7-0.4-1.7H53.6z  "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 92.5,
    rx: 15.6,
    ry: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6,31.8c0,0-3,4.6-12.2,0.4c-9.2-4.3-12.8-0.5-12.8-0.5l0,0c-1.9,8.3,4.5,16.4,12,17C56.1,49.2,64.3,41.5,62.6,31.8  L62.6,31.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVin);
export default __webpack_public_path__ + "static/media/vin.135a2ad4ae5aadc1138f6c4875ab0f8b.svg";
export { ForwardRef as ReactComponent };